import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2307306e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  class: "cm-align-center",
  style: {"cursor":"pointer"}
}
const _hoisted_5 = {
  t: "1784253877323",
  style: {"color":"#f0a443","font-weight":"bold","font-size":"17px","margin-right":"4px"},
  width: "17px",
  height: "17px",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6877"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M512 853.333333a341.333333 341.333333 0 1 0 0-682.666666 341.333333 341.333333 0 0 0 0 682.666666z m0 85.333334C276.352 938.666667 85.333333 747.648 85.333333 512S276.352 85.333333 512 85.333333s426.666667 191.018667 426.666667 426.666667-191.018667 426.666667-426.666667 426.666667z m-42.666667-256h85.333334v85.333333h-85.333334v-85.333333z m0-426.666667h85.333334v341.333333h-85.333334V256z",
  fill: "#f0a443",
  "p-id": "6878"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { style: {"color":"#f0a443"} }
const _hoisted_9 = { class: "cm-ui-bold-txt" }

import { reactive, ref, computed, PropType, onMounted, nextTick } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import { getRiskPortDisplayTextForPortRange } from '@/utils/port-risk-display'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import {
  BlockViewService,
  QueryParams as BlockQueryParams,
  BlockPortItem,
} from '../block-view/block-view.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  FormSize,
  ObjectFormItem,
} from '@/components/cmForm/types'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { TableViewMode, TableViewModeType } from '@/views/dashboard/_enum/table-view-mode'
import { ServicePermissionService, PermissionFe } from '@/services/service-permission.service'
import { ElMessage } from 'element-plus'

type ExcludeBlockRequestParams = Extract<keyof BlockQueryParams, 'key_word' | 'limit' | 'page' | 'asc' | 'sort'>

export default /*#__PURE__*/_defineComponent({
  __name: 'blocked-port-list',
  props: {
  viewMode: {
    type: String as PropType<TableViewModeType>,
    default: TableViewMode.preview
  },
},
  emits: ['viewAll', 'unblockPort'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t, te, locale } = useI18n()

const props = __props

const emits = __emit

const injector = useReflectiveInjector()
const blockViewService = injector.get(BlockViewService)
const servicePermissionService = injector.get(ServicePermissionService)
const dataApi = blockViewService.getBlockPortRuleList.bind(blockViewService)
const hasPermission = servicePermissionService.getHasPermission(PermissionFe.port_control)

const tableRef = ref()

const { refreshList } = useCmTableListRefresh(tableRef)
const queryParams = reactive<Partial<BlockQueryParams>>({
  page: 1,
  limit: props.viewMode === TableViewMode.preview ? 10 : 20,
  key_word: '',
  asc: false,
  sort: 'device_count'
})
const selectedRows = ref<BlockPortItem[]>([])

const filterFormColumns = reactive<ObjectFormItem<BlockQueryParams, ExcludeBlockRequestParams>>({})

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    columnOpt: { label: t('portManage.operation'), width: 120, align: 'left', fixed: 'right' },
    actionButtons: (rowItem: BlockPortItem) => [
      {
        name: t('portManage.unblock'),
        type: 'unblock',
        opt: { size: FormSize.Small, text: true, type: 'text' },
        events: {
          click() {
            handleUnblockPort(rowItem)
          }
        }
      },
    ],
  }
})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : 'background: transparent;padding:0',
    containerOpt: { style: 'padding: 0;background: var(--cm-color-card-bg)' },
    path: 'list',
    height: props.viewMode === TableViewMode.preview ? undefined : '100%',
    showActionBar: false,
    showForm: false,
    showRightToolbar: false,
    rowKey: (row) => `${Number(row.system_type)}_${Number(row.rule_id)}`,
    selection: true,
    showTip: false,
    usePagination: false,
    disableScrollLoad: props.viewMode === TableViewMode.preview,
    scrollLoadThreshold: 10,
    scrollLoadDelay: 100,
    columns: [
      {
        label: t('portManage.portNum'),
        prop: 'port_num',
        sortable: true,
      },
      {
        label: t('portManage.systemType'),
        prop: 'system_type',
        sortable: true,
      },
      {
        label: t('portManage.riskRef'),
        prop: 'risk_reference',
      },
      {
        label: t('portManage.deviceCount'),
        prop: 'device_count',
        sortable: true,
      },
    ],
  }
})

function getSystemTypeLabel(systemType: number): string {
  if (systemType === 1) return 'Windows'
  if (systemType === 2) return 'Linux'
  if (systemType === 3) return 'WinServer'
  return '--'
}

async function handleSearch(value: string) {
  await nextTick()
  queryParams.key_word = value
  void refreshList()
}

async function handleQuery() {
  await refreshList()
}

function handleReset() {
  queryParams.key_word = ''
  void refreshList()
}

function handleUnblockPort(row: BlockPortItem) {
  emits('unblockPort', row)
}

function handleSelectionChange(rows: BlockPortItem[]) {
  selectedRows.value = rows
}

async function handleBatchUnblock() {
  if (!selectedRows.value.length) return
  try {
    await blockViewService.resetBlockRule({
      select_type: 1,
      rule_id_list: selectedRows.value.map((row) => row.rule_id),
      system_types: [...new Set(selectedRows.value.map((row) => row.system_type))],
    })
    ElMessage.success(t('portManage.relieveSuccess'))
    selectedRows.value = []
    ;(tableRef.value as any)?.tableRef?.clearSelection?.()
    await refreshList()
  } catch {
    ElMessage.error(t('portManage.relieveFailed'))
  }
}

function handleAction({ type }: { type: any }) {
  // Handle actions
}

onMounted(async () => {
  if (!hasPermission) return
  await refreshList()
})

__expose({
  tableRef,
  getList: () => void refreshList(),
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    tableOpt: tableOpt.value,
    tableActOpt: tableActOpt.value,
    firstLoading: false,
    "has-permission": _unref(hasPermission),
    api: _unref(dataApi),
    modelValue: queryParams,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams) = $event)),
    pageOption: {
      style: 'padding-bottom: 16px',
      pageNumName: 'page',
      pageSizeName: 'limit',
    },
    onHandleAction: handleAction,
    onChangeSelected: handleSelectionChange
  }, {
    header: _withCtx(() => [
      _createVNode(SearchFilterBar, {
        modelValue: queryParams,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams) = $event)),
        "form-columns": filterFormColumns,
        disabled: !_unref(hasPermission),
        "show-search": true,
        "search-placeholder": _ctx.$t('portManage.portNum'),
        "popover-threshold": 4,
        onSearch: handleSearch,
        onQuery: handleQuery,
        onReset: handleReset
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            plain: "",
            disabled: !selectedRows.value.length || !_unref(hasPermission),
            onClick: handleBatchUnblock
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('portManage.batchUnblock')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          (props.viewMode === _unref(TableViewMode).preview)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "small",
                disabled: !_unref(hasPermission),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewAll')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"])
    ]),
    port_num: _withCtx(({ row }) => [
      (row.port_start === row.port_end)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row.port_start), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(`${row.port_start} ~ ${row.port_end}`), 1))
    ]),
    system_type: _withCtx(({ value }) => [
      _createElementVNode("span", null, _toDisplayString(getSystemTypeLabel(value)), 1)
    ]),
    risk_reference: _withCtx(({ row }) => [
      (!row.is_known_risk)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('portManage.unknown')), 1))
        : (_openBlock(), _createBlock(_component_el_popover, {
            key: 1,
            placement: "bottom-start",
            width: 380,
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('portManage.risk')), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('portManage.riskLabel')), 1),
                _createTextVNode(_toDisplayString(_unref(getRiskPortDisplayTextForPortRange)(_unref(t), _unref(te), row.port_start, row.port_end, row.system_type, row.risk_detail)), 1)
              ])
            ]),
            _: 2
          }, 1024))
    ]),
    device_count: _withCtx(({ row }) => [
      _createVNode(_component_el_button, {
        type: "text",
        onClick: ($event: any) => (handleUnblockPort(row))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(row.device_count), 1)
        ]),
        _: 2
      }, 1032, ["onClick"])
    ]),
    _: 1
  }, 8, ["tableOpt", "tableActOpt", "has-permission", "api", "modelValue"]))
}
}

})